import React, { useContext, useState, useEffect } from 'react'
import ClassNames from 'classnames'

import Popover from 'Components/Popover'
import { NavbarItem } from '../NavbarItem/NavbarItem'
import GarageDropdown from './GarageDropdown'

import { VehicleContext} from 'Contexts/VehicleContext'
import { NavigationContext } from 'Contexts/Navigation/NavigationContext'
import { UserContext } from 'Contexts/UserContext/UserContext'

import headerStyles from '../Header.module.scss'

const GarageSection = ({ services }) => {
    try {
        const { context: vehicleState, ExecuteGarageReload} = useContext(VehicleContext)
        const {state: navigationState, dispatch: navigationDispatch, setYmmModal: setModal } = useContext(NavigationContext)
        const { context: userState } = useContext(UserContext)
        const { garage } = navigationState
        const { isGarageDropdownOpen } = garage
        const [customRef, setCustomParentTriggerRef] = useState(null)

        useEffect(() => {
            if (typeof window !== 'undefined') {
                if (window.SMI) {
                    window.SMI.showDs9YMMDropdown = function (
                        market = 'street',
                        reloadCurrentLocation = false
                    ) {
                        const totalCustomerVehicles = vehicleState?.customerVehicles
                            ? vehicleState.customerVehicles.length
                            : 0

                        if (totalCustomerVehicles === 0) {
                            setModal(true);
                            ExecuteGarageReload(reloadCurrentLocation);
                            return
                        }

                        if (totalCustomerVehicles > 0 && customRef) {
                            customRef.click()
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            })
                            navigationDispatch({
                                type: 'setGarageState',
                                payload: {
                                    garageState: {
                                        isGarageDropdownOpen: true,
                                        market: market
                                    }
                                }
                            })
                            ExecuteGarageReload(reloadCurrentLocation)
                        }
                    }
                }
            }
        }, [typeof window, customRef, vehicleState?.customerVehicles])

        const handleToggleGarageDropdown = (isOpen) => {
            navigationDispatch({
                type: 'setGarageState',
                payload: { garageState: { isGarageDropdownOpen: isOpen } }
            })
        }

        let vehicle = getSelectedVehicle(vehicleState.selectedVehicle)
        const totalCustomerVehicles = vehicleState?.customerVehicles ? vehicleState.customerVehicles.length : 0
        let displayText = vehicle?.displayName ?? (totalCustomerVehicles > 0 ? 'Select A Vehicle' : 'Add a Vehicle')
        
        return (
            <Popover
                content={
                    <GarageDropdown userGuid={userState.userGuid} services={services} />
                }
                setCustomParentTriggerRef={setCustomParentTriggerRef}
                isOpen={isGarageDropdownOpen}
                onToggleMenu={handleToggleGarageDropdown}
                className={ClassNames(
                    headerStyles.headerItem,
                    headerStyles.mobileHide,
                    headerStyles.mobileLimitedHide,
                    headerStyles.headerGarage
                )}
            >
                <NavbarItem
                    icon={'garage'}
                    badge
                    badgeProps={{ intent: 'action', number: totalCustomerVehicles, size: 'small', removeNumber: true }}
                    primaryText={'My Garage'}
                    secondaryTextOptions={{
                        className: ClassNames(
                            headerStyles.headerGarageTextWrapper,
                            headerStyles.headerOverflowText
                        )
                    }}
                    secondaryText={displayText}
                    hover
                    data-testid={'Garage'}
                />
            </Popover>
        )
    } catch (e) {
        console.error(e)
        return false
    }
}

function getSelectedVehicle(selectedVehicle) {
    if(!selectedVehicle){
        return false
    }

    if (selectedVehicle.shopUrl && selectedVehicle.raceDisplay) {
        return {
            displayName: selectedVehicle.raceDisplay,
            shopUrl: selectedVehicle.shopUrl
        }
    } else if (
        selectedVehicle.shopUrl &&
        selectedVehicle.yearId &&
        selectedVehicle.modelDisplay
    ) {
        let year = selectedVehicle.yearId.toString()
        return {
            displayName: `${year} ${selectedVehicle.modelDisplay}`,
            shopUrl: selectedVehicle.shopUrl
        }
    }
    return false
}

export default GarageSection
